import React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const RoundedBack = (props) => {
  const { height = 24, width = 24 } = props;
  return (
    <Svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle cx="18" cy="18" r="18" fill="white" />
      <Path
        d="M25.9181 17.2723C25.8445 17.2607 25.7699 17.2554 25.6953 17.2563H12.9967L13.2736 17.1312C13.5443 17.0067 13.7905 16.8373 14.0013 16.6306L17.5623 13.1704C18.0313 12.7353 18.1101 12.0355 17.749 11.5122C17.3288 10.9546 16.5229 10.8335 15.949 11.2418C15.9027 11.2748 15.8586 11.3108 15.8172 11.3495L9.37772 17.6067C8.87448 18.0952 8.87404 18.8875 9.37672 19.3765C9.37704 19.3768 9.3774 19.3772 9.37772 19.3775L15.8172 25.6347C16.3208 26.1227 17.1363 26.1216 17.6385 25.6322C17.6781 25.5937 17.715 25.5527 17.749 25.5096C18.1101 24.9863 18.0313 24.2864 17.5623 23.8514L14.0077 20.3849C13.8187 20.2011 13.6015 20.047 13.3637 19.9281L12.9774 19.7592H25.6245C26.2824 19.7829 26.8596 19.3364 26.9832 18.708C27.0971 18.0258 26.6202 17.383 25.9181 17.2723Z"
        fill="black"
        fill-opacity="0.8"
      />
    </Svg>
  );
};

export default RoundedBack;
